module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1031-0d1d4bc70402747fff51e975fe1f9b37.png";